/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FeedbackIssueType = {
    Skills: 'SKILLS',
    JobTitle: 'JOB_TITLE',
    JobCategory: 'JOB_CATEGORY',
    JobDescription: 'JOB_DESCRIPTION',
    ResultsRelevancy: 'RESULTS_RELEVANCY',
    Location: 'LOCATION',
    Languages: 'LANGUAGES',
    ExperienceLevel: 'EXPERIENCE_LEVEL',
    Other: 'OTHER'
} as const;
export type FeedbackIssueType = typeof FeedbackIssueType[keyof typeof FeedbackIssueType];


export function instanceOfFeedbackIssueType(value: any): boolean {
    for (const key in FeedbackIssueType) {
        if (Object.prototype.hasOwnProperty.call(FeedbackIssueType, key)) {
            // @ts-ignore
            if (FeedbackIssueType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FeedbackIssueTypeFromJSON(json: any): FeedbackIssueType {
    return FeedbackIssueTypeFromJSONTyped(json, false);
}

export function FeedbackIssueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackIssueType {
    return json as FeedbackIssueType;
}

export function FeedbackIssueTypeToJSON(value?: FeedbackIssueType | null): any {
    return value as any;
}

